import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    minHeight: 50,
    backgroundColor: '#EFF6F9',
    padding: 0,
  },
}));

export default {};
